import { StyledForm } from '../../Form/style';
import { useIntl } from 'react-intl';
import { Checkbox } from 'antd';

interface StatusCheckboxesProps {
  public?: boolean;
  availableOptions?: string[];
}

export const StatusCheckboxes = ({ public: isPublic, availableOptions }: StatusCheckboxesProps) => {
  const intl = useIntl();

  const prefix = isPublic ? 'listing.status.public' : 'listing.status';

  const allStatusOptions = [
    { value: 'closed', label: intl.formatMessage({ id: `${prefix}.closed` }) },
    { value: 'completed', label: intl.formatMessage({ id: `${prefix}.completed` }) },
    { value: 'cancelled', label: intl.formatMessage({ id: `${prefix}.cancelled` }) },
    { value: 'unsuccessful', label: intl.formatMessage({ id: `${prefix}.unsuccessful` }) },
  ];

  const statusOptions = availableOptions
    ? allStatusOptions.filter(option => availableOptions.includes(option.value))
    : allStatusOptions;

  return (
    <div className="status-checkboxes">
      <label className="filter-label">
        {intl.formatMessage({ id: 'listing.filter.status' })}
      </label>
      <StyledForm.Item name="status">
        <Checkbox.Group options={statusOptions} />
      </StyledForm.Item>
    </div>
  );
};